import { RoleOptions } from '@contexts/users/domain';

import type { BreadcrumbConfig } from '@components/molecules/breadcrumbs/models/breadcrumb';
import type { DynamicOptionsParams } from '@components/molecules/breadcrumbs/services/breadcrumbs.service';

import { routesMetadata } from '@shared/models';
import type { AccessContext, AccessStrategy, WidgetConfig } from '@shared/services';

export class AdminAccessStrategy implements AccessStrategy {
	getWidgets(): WidgetConfig[] {
		return [
			{
				id: 'companies',
				label: 'entities.companies.title',
				routerLink: routesMetadata.companies.relative,
				icon: 'company'
			},
			{
				id: 'delegations',
				label: 'entities.delegations.title',
				routerLink: routesMetadata.delegations.relative,
				icon: 'delegation'
			},
			{
				id: 'users',
				label: 'entities.users.title',
				routerLink: routesMetadata.users.relative,
				icon: 'users'
			},
			{
				id: 'recorded-devices',
				label: 'entities.recordedDevices.title',
				routerLink: routesMetadata.recordedDevices.relative,
				icon: 'device'
			},
			{
				id: 'commands',
				label: 'entities.commands.title',
				routerLink: routesMetadata.commands.relative
			}
		];
	}

	private buildBaseBreadcrumbs(): BreadcrumbConfig {
		return {
			levels: [
				{
					id: 'section',
					controlsSegmentAt: 0,
					options: [
						{
							id: 'companies',
							label: 'entities.companies.title',
							segment: routesMetadata.companies.relative,
							navigable: true
						},
						{
							id: 'delegations',
							label: 'entities.delegations.title',
							segment: routesMetadata.delegations.relative,
							navigable: true
						},
						{
							id: 'users',
							label: 'entities.users.title',
							segment: routesMetadata.users.relative,
							navigable: true
						},
						{
							id: 'recorded-devices',
							label: 'entities.recordedDevices.title',
							segment: routesMetadata.recordedDevices.relative,
							navigable: true
						},
						{
							id: 'commands',
							label: 'entities.commands.title',
							segment: routesMetadata.commands.relative,
							navigable: true
						}
					]
				},
				{
					id: 'device-tabs',
					controlsSegmentAt: 1,
					visibleWhen: {
						rootSegmentIs: routesMetadata.recordedDevices.relative,
						segmentAtIs: {
							index: 1,
							values: []
						}
					},
					options: [
						{
							id: 'import-devices',
							label: 'entities.recordedDevices.pages.import.title',
							segment: routesMetadata.import.relative,
							navigable: true
						},
						{
							id: 'update-devices',
							label: 'entities.recordedDevices.pages.update.title',
							segment: routesMetadata.update.relative,
							navigable: true
						},
						{
							id: 'changeDelegationGroup-devices',
							label: 'entities.recordedDevices.pages.change.title',
							segment: routesMetadata.changeDelegationGroup.relative,
							navigable: true
						}
					]
				}
			]
		};
	}

	async getBreadcrumbs(_: AccessContext): Promise<[BreadcrumbConfig, DynamicOptionsParams[]]> {
		const baseConfig = this.buildBaseBreadcrumbs();

		return [baseConfig, []];
	}

	canAccess(roles: string[]): boolean {
		return roles.includes(RoleOptions.ADMIN);
	}
}
